import { useTranslator } from "../../i18n/context.js";
import { renderElement } from "../../utils/use-render.js";
import { useDialogContext } from "../dialog/context.js";
import { getErrorDialogTitleText } from "@videojs/core";
import { translateText } from "@videojs/core/i18n";
import { forwardRef } from "react";
//#region src/ui/error-dialog/title.tsx
/** Renders the localized error dialog heading, or authored children when provided. */
const ErrorDialogTitle = forwardRef(function ErrorDialogTitle({ render, className, style, children, ...elementProps }, forwardedRef) {
	const t = useTranslator();
	const { state, stateAttrMap } = useDialogContext();
	const content = children ?? translateText(getErrorDialogTitleText(), t);
	return renderElement("h2", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: forwardedRef,
		props: [{
			id: state.titleId,
			children: content
		}, elementProps]
	});
});
//#endregion
export { ErrorDialogTitle };

//# sourceMappingURL=title.js.map